import React, { useState, useEffect } from "react";
import Disclaimer from "./Disclaimer";

const CrifScoreReportModal = ({
  isOpen,
  onClose,
  crifV4Report,
  crifV4Error,
  displayMessageBlock = true,
  reportMessage = "",
  reportCode = "",
  isPdf,
}) => {
  const [isPrinting, setIsPrinting] = useState(false);

  // useEffect(() => {
  //   console.log("crif v4", crifV4Report?.data?.result_json?.credit_report);
  // }, [crifV4Report, crifV4Error]);

  if (!isOpen) return null;

  const printDiv = () => {
    setIsPrinting(true);
    const printWindow = window.open("", "", "height=700,width=1000");
    const printContents =
      document.getElementById("invoicedata")?.innerHTML || "";

    printWindow.document.write("<html><head><title>Crif Score Report</title>");
    printWindow.document.write(
      '<link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">',
    );
    printWindow.document.write("</head><body>");
    printWindow.document.write(printContents);
    printWindow.document.write("</body></html>");
    printWindow.document.close();
    printWindow.focus();

    setTimeout(() => {
      printWindow.print();
      setIsPrinting(false);
    }, 100);
  };

  // For success response, crifV4Report should be the API JSON you pasted:
  // { status: {...}, message: "...", data: { report_data: {...} } }
  const modalData = isPdf
    ? crifV4Report?.report_data?.crifData
    : crifV4Report?.data?.credit_report?.crifData ||
      crifV4Report?.data?.report_data?.crifData ||
      crifV4Report?.data?.report_data?.["REPORT-DATA"] ||
      crifV4Report?.data?.result_json?.credit_report ||
      crifV4Report?.credit_report?.crifData ||
      {};
  const modalDataError = crifV4Error || null;

  const accountDetails = modalData?.response;

  const formatLabel = (key) =>
    key
      .replace(/[-_]/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (c) => c.toUpperCase());

  const splitIntoColumns = (obj, columns = 3) => {
    const entries = Object.entries(obj || {});
    const result = Array.from({ length: columns }, () => []);
    entries.forEach((item, index) => {
      result[index % columns].push(item);
    });
    return result;
  };

  //  const personalInfo = modalData?.["STANDARD-DATA"]?.DEMOGS || {};
  //             console.log("personalInfo", personalInfo );

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center z-50 backdrop-blur-sm bg-white bg-opacity-50 md:p-0 p-4">
      <div
        className="bg-white rounded-lg shadow-lg w-full md:max-w-4xl overflow-y-auto max-h-[100vh]"
        id="invoicedata"
      >
        <div className="a4-page">
         
          {/* Header Section */}
          <div className="grid grid-cols-12 items-center gap-2 border-b-[3px] border-b-blue-900 pb-4  mt-1">
            {(() => {
              const formatKey = (key) =>
                key
                  .replace(/-/g, " ")
                  .replace(/_/g, " ")
                  .split(" ")
                  .map(
                    (word) =>
                      word.charAt(0).toUpperCase() +
                      word.slice(1).toLowerCase(),
                  )
                  .join(" ");

              const nameVariations =
                modalData?.["personal_info_variation"]?.["name_variations"]
                  ?.variation || [];

              const latestName = Array.isArray(nameVariations)
                ? nameVariations[nameVariations.length - 1]?.value
                : nameVariations?.value ||
                  (modalDataError?.data?.first_name &&
                  modalDataError?.data?.last_name
                    ? `${modalDataError.data.first_name} ${modalDataError.data.last_name}`
                    : modalDataError?.data?.first_name ||
                      modalDataError?.first_name ||
                      "N/A");

              return (
                <>
                  <div className="col-span-12  sm:col-span-3 flex justify-center sm:justify-start">
                    <img
                      src="https://imgs.search.brave.com/F-FGsx3dw-ufK7fWVZmHd93EObunBV0adl6hfaiK9Zs/rs:fit:0:180:1:0/g:ce/aHR0cHM6Ly9kMjh3/dThvNml0djg5dC5j/bG91ZGZyb250Lm5l/dC9pbWFnZXMvQ1JJ/RmhpZ2htYXJrcG5n/LTE1NzQ4NDY5NTk0/NjgucG5n"
                      className="w-12 sm:w-28 md:w-28 lg:h-20 lg:w-36 [filter:contrast(1.1)_saturate(1.1)]"
                      alt="Logo"
                    />
                  </div>

                  <div className="col-span-12 sm:col-span-6 text-center">
                    <h4 className="text-base sm:text-md tracking-wide md:text-xl text-blue-900 font-bold">
                      CONSUMER CREDIT™ REPORT
                    </h4>
                    <p className="text-sm sm:text-[14px] mt-1">
                      <span className="font-bold">For</span>{" "}
                      <span className="font-bold">{latestName}</span>
                    </p>
                  </div>

                  {/* <div className="col-span-12 sm:col-span-3 text-center sm:text-right text-xs sm:text-[10px]">

                        <p >
                          <span className="font-bold text-blue-600">
                            CHM Ref #
                          </span>{" "}
                          <span className="font-semibold">B2C{new Date()}</span>
                        </p>
                    
                  </div> */}
                </>
              );
            })()}
          </div>

          {/* Inquiry Input Info */}
          <div className="bg-blue-300 text-black px-2 py-1 mt-2 text-[16px] font-semibold">
            Inquiry Input Information
          </div>

          {(() => {
            const user = modalData?.customer_identity;

            return (
              <div className="grid grid-cols-2 text-xs font-semibold pl-2 pt-4 gap-2">
                <p>
                  Name:{" "}
                  <span className="text-rose-800 pl-2 text-[10px] font-bold">
                    {" "}
                    {user?.name}
                  </span>
                </p>
                <p>
                  Phone Number:{" "}
                  <span className="text-rose-800 pl-2 text-[10px] font-bold">
                    {" "}
                    {user?.phone}
                  </span>
                </p>
                <p>
                  Id:{" "}
                  <span className="text-rose-800 pl-2 text-[10px] font-bold">
                    {" "}
                    {user?.pan}
                  </span>
                </p>
                <p>
                  Email:{" "}
                  <span className="text-rose-800 pl-2 text-[10px] font-bold">
                    {" "}
                    {user?.email}
                  </span>
                </p>
              </div>
            );
          })()}

          {/* Credit Score */}
          <div className="bg-blue-300 md:text-black px-2 py-1 mt-8 text-[16px] text-black  font-semibold">
            CRIF Credit Score
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full table-auto  text-left text-sm">
              {(() => {
                const scoresData = modalData?.scores;

                if (!scoresData) {
                  return (
                    <tbody>
                      <tr>
                        <td
                          colSpan="3"
                          className="border border-black px-4 py-8 text-center text-gray-500"
                        >
                          No score details available
                        </td>
                      </tr>
                    </tbody>
                  );
                }

                const scoresArray = Array.isArray(scoresData)
                  ? scoresData
                  : [scoresData];

                if (scoresArray.length === 0) {
                  return (
                    <tbody>
                      <tr>
                        <td
                          colSpan="3"
                          className=" px-4 py-8 text-center text-gray-500"
                        >
                          No score details available
                        </td>
                      </tr>
                    </tbody>
                  );
                }

                const formatKey = (key) =>
                  key
                    .replace(/-/g, " ")
                    .replace(/_/g, " ")
                    .split(" ")
                    .map(
                      (word) =>
                        word.charAt(0).toUpperCase() +
                        word.slice(1).toLowerCase(),
                    )
                    .join(" ");

                return (
                  <>
                    <thead className="bg-blue-100">
                      <tr className="text-left text-[14px] text-blue-900 font-semibold">
                        <th className=" uppercase px-3 py-2 w-1/4">
                          Score Name
                        </th>
                        <th className=" uppercase px-3 py-2 w-1/4">Range</th>
                        {/* <th className=" uppercase px-3 py-2 w-1/2">
                          Factors
                        </th> */}
                        <th className=" uppercase px-3 py-2 w-1/4 text-center">
                          Score
                        </th>
                        <th className=" uppercase px-3 py-2 w-1/4 text-center">
                          Description
                        </th>
                      </tr>
                    </thead>
                    <tbody className="text-xs">
                      {scoresArray.map((score, idx) => {
                        if (!score || typeof score !== "object") return null;

                        const keys = Object.keys(score);

                        const scoreTypeKey = keys.find((key) => {
                          const lower = key.toLowerCase();
                          return (
                            lower.includes("type") ||
                            lower.includes("name") ||
                            lower.includes("bureau")
                          );
                        });
                        const scoreType = scoreTypeKey
                          ? score[scoreTypeKey]
                          : "Credit Score";

                        const factorsKey = keys.find((key) => {
                          const lower = key.toLowerCase();
                          return (
                            lower.includes("factor") ||
                            lower.includes("factors") ||
                            lower.includes("element") ||
                            lower.includes("reason")
                          );
                        });
                        const factorsValue = factorsKey
                          ? score[factorsKey]
                          : "";
                        const factors = factorsValue
                          ? String(factorsValue)
                              .split("|")
                              .filter((f) => f && f.trim())
                          : [];

                        const scoreValueKey = keys.find((key) => {
                          const lower = key.toLowerCase();
                          return (
                            lower.includes("value") ||
                            (lower.includes("score") &&
                              !lower.includes("type") &&
                              !lower.includes("factor"))
                          );
                        });
                        const scoreValue = scoreValueKey
                          ? score[scoreValueKey]
                          : "N/A";

                        // console.log("scoreValue", scoreValue);
                        // console.log("scoreValueKey", scoreValueKey);

                        // console.log("factors", factors);
                        // console.log("factorsKey", factorsKey);
                        // console.log("factorsValue", factorsValue);

                        return (
                          <tr key={idx} className="hover:bg-gray-50">
                            <td className="border px-3 py-3 align-top">
                              <div>
                                <span className="font-semibold text-black block">
                                  {scoreType || "N/A"}
                                </span>
                                {/* {scoreTypeKey && (
                                  <span className="text-[10px] text-gray-500 mt-1 block">
                                    ({formatKey(scoreTypeKey)})
                                  </span>
                                )} */}
                              </div>
                            </td>
                            <td className="border px-3 py-3 align-top">
                              <div>
                                <span className="font-semibold text-black block">
                                  300-900
                                </span>
                              </div>
                            </td>

                            {/* <td className=" px-3 py-3 align-top">
                              {factors.length > 0 ? (
                                <div>
                                  <ul className="list-disc list-inside space-y-1">
                                    {crifV4Report?.data?.report_data?.[
                                      "HEADER-SEGMENT"
                                    ]
                                      ? factorsValue?.map((fctr, i) => (
                                          <li
                                            key={i}
                                            className="break-words text-gray-700 leading-relaxed"
                                          >
                                            {fctr?.TYPE.trim()}
                                          </li>
                                        ))
                                      : factors.map((factor, i) => (
                                          <li
                                            key={i}
                                            className="break-words text-gray-700 leading-relaxed"
                                          >
                                            {factor.trim()}
                                          </li>
                                        ))}
                                  </ul>
                                  {factorsKey && (
                                    <span className="text-[10px] text-gray-500 mt-2 block">
                                      ({formatKey(factorsKey)})
                                    </span>
                                  )}
                                </div>
                              ) : (
                                <span className="text-gray-500 italic">
                                  No factors available
                                </span>
                              )}
                            </td> */}

                            <td className="border px-2 py-1 align-middle">
                              <div className="flex items-center justify-center">
                                <div className="text-[14px] font-semibold text-black ">
                                  {scoreValue}
                                </div>
                              </div>
                            </td>
                            <td className="border px-2 py-1 align-middle">
                              <div className="flex items-center justify-center">
                                <div className="text-[14px] font-semibold text-black ">
                                  -
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </>
                );
              })()}
            </table>
          </div>

          {/* Account Information */}
          <div className="bg-blue-300 text-black px-2 py-1 mt-8  text-[16px] font-semibold">
            Score Trend
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full table-auto  text-left text-sm">
              {(() => {
                const trendsData = modalData?.trends;

                if (!trendsData) {
                  return (
                    <tbody>
                      <tr>
                        <td
                          colSpan="3"
                          className="border border-black px-4 py-8 text-center text-gray-500"
                        >
                          No score details available
                        </td>
                      </tr>
                    </tbody>
                  );
                }

                return (
                  <>
                    <tbody className="bg-blue-50">
                      <tr className="text-left text-[10px] text-blue-900 font-semibold">
                        <th className="border border-black/30 uppercase px-3  w-1/4">
                          Retro Date
                        </th>

                        {trendsData?.dates?.split("|")?.map((item, idx) => {
                          if (idx > 11) return null;
                          return (
                            <td
                              key={idx}
                              className="border border-black/30 text-xs p-2"
                            >
                              {item}
                            </td>
                          );
                        })}
                      </tr>
                      <tr className="text-left text-[10px] text-blue-900 font-semibold">
                        <th className="border border-black/30 uppercase px-3  w-1/4">
                          Score
                        </th>
                        {trendsData?.values?.split("|")?.map((item, idx2) => {
                          if (idx2 > 11) return null;
                          return (
                            <td
                              key={idx2}
                              className="border border-black/30 p-2"
                            >
                              {item}
                            </td>
                          );
                        })}
                      </tr>
                      <tr className="text-left text-[10px] text-blue-900 font-semibold">
                        <th className="border border-black/30 uppercase px-3  w-1/4">
                          Description
                        </th>

                        {Array.from({ length: 12 }).map((_, idx3) => {
                          return (
                            <td
                              key={idx3}
                              className="border border-black/30 p-2"
                            >
                              -
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </>
                );
              })()}
            </table>
          </div>

          {/* Summary Tables from account_summary */}
          <div>
            {/* <div className="bg-blue-300 text-black p-2 mt-8 text-sm font-semibold">
              Summary
            </div> */}

            {modalData?.["account_summary"] &&
              Object.keys(modalData["account_summary"]).map((sectionKey) => (
                <div key={sectionKey}>
                  <div className="bg-blue-300 text-black px-2 py-1 mt-8  text-[16px] font-semibold">
                    {sectionKey.replace(/_/g, " ").charAt(0).toUpperCase() +
                      sectionKey.replace(/_/g, " ").slice(1)}
                  </div>

                  <table className="w-full border text-[9px] mb-2">
                    <thead className="bg-blue-50">
                      <tr>
                        {Object.keys(
                          modalData["account_summary"][sectionKey],
                        ).map((field) => (
                          <th key={field} className="border px-2 py-1">
                            {field.replace(/_/g, " ")}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody className="bg-white">
                      <tr>
                        {Object.entries(
                          modalData["account_summary"][sectionKey],
                        ).map(([field, value]) => (
                          <td
                            key={field}
                            className={`border px-2 py-1 font-semibold ${
                              field.includes("OVERDUE")
                                ? "text-red-600"
                                : field.includes("AMOUNT") ||
                                    field.includes("BALANCE")
                                  ? "text-green-600"
                                  : "text-gray-700"
                            }`}
                          >
                            {field.includes("AMOUNT") ||
                            field.includes("BALANCE")
                              ? "₹"
                              : ""}
                            {value || "N/A"}
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </div>
              ))}
          </div>

          <Disclaimer />

          <div className="bg-[#F8D7B5] text-black px-2 py-1 mt-8  text-[16px] font-semibold">
            Personal Info Variations
          </div>

          {(() => {
            const personalInfo = modalData?.["personal_info_variation"];

            if (!personalInfo) return null;

            return Object.entries(personalInfo)?.map(([key, value]) => {
              if (value?.variation?.length > 0) {
                return (
                  <table className="w-full text-sm mb-10 table-fixed border-collapse">
                    <thead>
                      <tr className="border-b-2 text-indigo-800 border-b-indigo-800">
                        <th className="w-3/4 text-left p-2 ">
                          {key.replace(/_/g, " ").charAt(0).toUpperCase() +
                            key.replace(/_/g, " ").slice(1)}
                        </th>
                        <th className="w-1/4 text-left p-2 ">Reported Date</th>
                      </tr>
                    </thead>

                    <tbody>
                      {value?.variation?.map((item, idx) => (
                        <tr
                          key={idx}
                          className={`${idx % 2 === 0 && "bg-gray-100"} text-xs font-semibold`}
                        >
                          <td className="p-2 break-words">
                            {item?.value || "-"}
                          </td>
                          <td className="p-2 break-words">
                            {item?.reported_date || "-"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                );
              }
            });
          })()}

          <Disclaimer />

          <div className="bg-[#F8D7B5] text-black px-2 py-1 mt-8  text-[16px] font-semibold">
            Employment Details
          </div>

          <div>
            <table className="w-full text-sm mb-10 table-fixed border-collapse">
              <thead>
                <tr className="border-b-2 text-indigo-800 border-b-indigo-800">
                  <th className="w-1/3 text-left p-2 ">Occupation</th>
                  <th className="w-1/3 text-left p-2 ">Reported Date</th>
                  <th className="w-1/3 text-left p-2 ">Account Type</th>
                </tr>
              </thead>

              {(() => {
                const employemnt = modalData?.employment_details;
                if (employemnt?.occupation) {
                  return (
                    <tbody>
                      <tr className={`bg-gray-100 text-xs font-semibold`}>
                        <td className="p-2 break-words">
                          {employemnt?.occupation || "-"}
                        </td>
                        <td className="p-2 break-words">
                          {employemnt?.date_reported || "-"}
                        </td>
                        <td className="p-2 break-words">
                          {employemnt?.acct_type || "-"}
                        </td>
                      </tr>
                    </tbody>
                  );
                } else {
                  return (
                    <tbody>
                      <tr className={"bg-gray-100 text-xs font-semibold"}>
                        <td className="p-2 break-words">------</td>
                        <td className="p-2 break-words">------</td>
                        <td className="p-2 break-words">------</td>
                      </tr>
                    </tbody>
                  );
                }
              })()}
            </table>
          </div>

          {/* Account Information */}
          <div className="bg-blue-300 md:text-black px-2 py-1 mt-8 text-[16px] text-black  font-semibold">
            Account Information
          </div>

          {Array.isArray(modalData?.response) && accountDetails?.length > 0 ? (
            accountDetails?.map((item, index) => {
              const account = item;

              // console.log("accountDetails", accountDetails);
              // console.log("account", account);

              const buildPaymentHistory = (combinedHistory) => {
                if (!combinedHistory) return { months: [], history: {} };

                const months = [
                  "Jan",
                  "Feb",
                  "Mar",
                  "Apr",
                  "May",
                  "Jun",
                  "Jul",
                  "Aug",
                  "Sep",
                  "Oct",
                  "Nov",
                  "Dec",
                ];
                const yearsData = {};

                const isNewResponse = crifV4Report?.data?.report_data?.[
                  "HEADER-SEGMENT"
                ]
                  ? true
                  : false;

                combinedHistory
                  .split("|")
                  .filter(Boolean)
                  .forEach((entry) => {
                    const [monthYear, status] = entry.split(",");
                    if (!isNewResponse && (!monthYear || !status)) return;

                    const [month, year] =
                      monthYear.split(":") || entry.split(":");

                    const monthIndex = months.findIndex(
                      (m) => m.toLowerCase() === month.toLowerCase(),
                    );
                    if (monthIndex === -1 || !year) return;

                    if (!yearsData[year]) yearsData[year] = Array(12).fill("-");
                    yearsData[year][monthIndex] = status?.trim();
                  });

                // console.log("yearsdata", yearsData);

                return { months, history: yearsData };
              };

              const correctDates = account?.HISTORY?.[0]?.DATES?.split("|");
              let historyForNewResponse = ``;

              correctDates?.forEach((item, idx) => {
                const d = account?.HISTORY?.[0]?.DATES?.split("|");
                const v = account?.HISTORY?.[0]?.VALUES?.split("|");

                historyForNewResponse = `${historyForNewResponse}${d[idx]},${v[idx]}${idx === correctDates?.length - 1 ? "" : "|"}`;
                return historyForNewResponse;
              });

              // defined new history for new Responses.

              const { months, history } = buildPaymentHistory(
                account?.["combined_payment_history"] || historyForNewResponse,
              );

              const getStatusColor = (value) => {
                if (value === "-") return "bg-white text-gray-400";
                if (value?.includes("XXX")) return "bg-gray-200 text-gray-600";
                if (value?.includes("000") || value?.includes("STD"))
                  return "bg-white text-gray-700";
                return "bg-white text-gray-700";
              };

              const columns = splitIntoColumns(account, 3);
              // console.log("columns", columns);

              const isNewResponse = crifV4Report?.data?.report_data?.[
                "HEADER-SEGMENT"
              ]
                ? true
                : false;

              return (
                <div
                  key={index}
                  className="mb-3 border border-gray-300 rounded bg-white shadow-sm"
                >
                  <div className="bg-blue-300 md:text-black px-2 py-2 text-[10px] text-black  font-semibold grid grid-cols-4">
                    <p>
                      <span className="px-2 py-1 mr-2 text-sm bg-blue-800 text-white">
                        {index + 1}
                      </span>
                      <span className="mr-2">Account Type</span>
                      <span className="text-rose-900 text-[12px] font-semibold">
                        {item?.acct_type}
                      </span>
                    </p>
                    <p>
                      <span className="mr-2">Credit Guarantor</span>
                      <span className="text-rose-900 text-[12px] font-semibold">
                        {item?.credit_guarantor}
                      </span>
                    </p>
                    <p>
                      <span className="mr-2">Account #</span>
                      <span className="text-rose-900 text-[12px] font-semibold">
                        {item?.acct_number}
                      </span>
                    </p>
                    <p>
                      <span className="mr-2">Date Reported</span>
                      <span className="text-rose-900 text-[12px] font-semibold">
                        {item?.date_reported}
                      </span>
                    </p>
                  </div>

                  <div className="flex">
                    <div
                      className={` text-white flex w-[20px] items-center ${item?.account_status === "Active" ? "bg-green-600" : "bg-red-600"}  `}
                    >
                      <p
                        className={`rotate-90 text-sm font-bold relative ${item?.account_status === "Active" ? "right-[11px]" : "right-[12px]"} `}
                      >
                        {item?.account_status === "Active"
                          ? "Active"
                          : "Closed"}
                      </p>
                    </div>

                    <div
                      className={`grid grid-cols-3 gap-x-3 gap-y-0 w-full  p-2 md:text-[10px] text-[9px] bg-blue-100`}
                    >
                      {columns.map((col, colIdx) => (
                        <div key={colIdx} className="space-y-1">
                          {col
                            .filter(
                              ([key]) =>
                                key !== "combined_payment_history" &&
                                key !== "acct_type" &&
                                key !== "credit_guarantor" &&
                                key !== "date_reported" &&
                                key !== "acct_number",
                            )
                            .map(([key, value]) => {
                              let displayValue = value;

                              // if (key === "HISTORY") return null;

                              // If value is an object, convert it to a readable string
                              if (value && typeof value === "object") {
                                if (
                                  key === "security_details" &&
                                  value["security_detail"]
                                ) {
                                  const sd = value["security_detail"];
                                  displayValue = `Type: ${sd["security_type"] || "N/A"}, Value: ${
                                    sd["security_value"] || "0"
                                  }`;
                                } else {
                                  displayValue = JSON.stringify(value);
                                }
                              }

                              return (
                                <p key={key} className="font-semibold">
                                  <span className="font-bold text-blue-800">
                                    {formatLabel(key)}:
                                  </span>{" "}
                                  {displayValue || "N/A"}
                                </p>
                              );
                            })}
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* payment history */}

                  <div className="overflow-x-auto mt-8 ">
                    <div className="text-blue-800 font-bold pl-2 pb-1">
                      Payment History/Asset Classification:
                    </div>
                    <table className="w-full text-center text-xs border-collapse">
                      <thead>
                        <tr className="bg-gray-100">
                          <th className="border p-1"></th>
                          {months.map((m, i) => (
                            <th
                              key={i}
                              className="border p-1 text-blue-700 font-bold"
                            >
                              {m}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {Object.keys(history).length ? (
                          Object.keys(history)
                            .sort((a, b) => b - a)
                            .map((year) => (
                              <tr key={year}>
                                <td className="border p-1 font-bold bg-gray-50">
                                  {year}
                                </td>
                                {history[year].map((v, i) => (
                                  <td
                                    key={i}
                                    className={`border p-1 text-[9px] ${getStatusColor(v)}`}
                                  >
                                    {v}
                                  </td>
                                ))}
                              </tr>
                            ))
                        ) : (
                          <tr>
                            <td colSpan={13} className="p-3 text-gray-500">
                              No payment history available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="border p-4 text-center text-xs bg-white">
              No account details available.
            </div>
          )}

          <Disclaimer />

          {/* Inquiry History */}
          <div className="bg-blue-300 text-black px-2 py-1 mt-2 text-[16px] font-semibold">
            Inquiry History
          </div>

          {(() => {
            const inquiries =
              modalData?.["inquiry_history"]?.history ||
              modalData?.["STANDARD-DATA"]?.["INQUIRY-HISTORY"];
            const list = Array.isArray(inquiries)
              ? inquiries
              : inquiries
                ? [inquiries]
                : [];

            if (list.length === 0)
              return (
                <div className="p-4 text-center text-xs">
                  No inquiry history
                </div>
              );

            const fields = Object.keys(list[0]);

            return (
              <table className="w-full border text-xs mb-2">
                <thead className="bg-gray-200">
                  <tr>
                    <th className="border px-2 py-1">#</th>
                    {fields.map((f) => (
                      <th key={f} className="border px-2 py-1">
                        {f.replace(/-/g, " ")}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="bg-white">
                  {list.map((item, i) => (
                    <tr key={i} className="hover:bg-gray-50">
                      <td className="border px-2 py-1 font-bold">{i + 1}</td>
                      {fields.map((f) => (
                        <td
                          key={f}
                          className={`border px-2 py-1 ${
                            f.includes("amount")
                              ? "text-green-600 font-bold"
                              : f.includes("DATE")
                                ? "text-blue-600"
                                : "text-gray-700"
                          }`}
                        >
                          {f.includes("amount") ? "₹" : ""}
                          {item[f] || "N/A"}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            );
          })()}

          {/* Legend / Static Codes */}
          <div className="w-full overflow-x-auto">
            <div className="bg-blue-300 text-black px-2 py-1 mt-2 text-[16px] font-semibold">
              Appendix
            </div>
            <table className="w-full border border-gray-300 text-[10px] font-semibold">
              <thead className="bg-blue-200">
                <tr>
                  <th className="border px-1 py-0.5 text-left">Section</th>
                  <th className="border px-1 py-0.5 text-left">Code</th>
                  <th className="border px-1 py-0.5 text-left">Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border px-1 py-0.5">Account Summary</td>
                  <td className="border px-1 py-0.5">
                    Number of Delinquent Accounts
                  </td>
                  <td className="border px-1 py-0.5">
                    Number of accounts defaulted within last 6 months
                  </td>
                </tr>
                <tr>
                  <td className="border px-1 py-0.5">
                    Account Information - Credit Grantor
                  </td>
                  <td className="border px-1 py-0.5">XXXX</td>
                  <td className="border px-1 py-0.5">
                    Credit grantor name undisclosed
                  </td>
                </tr>
                <tr>
                  <td className="border px-1 py-0.5">
                    Account Information - Account #
                  </td>
                  <td className="border px-1 py-0.5">XXXX</td>
                  <td className="border px-1 py-0.5">
                    Account number undisclosed
                  </td>
                </tr>
                <tr>
                  <td className="border px-1 py-0.5">
                    Payment History / Asset Classification
                  </td>
                  <td className="border px-1 py-0.5">XXX</td>
                  <td className="border px-1 py-0.5">
                    Data not reported by institution
                  </td>
                </tr>
                <tr>
                  <td className="border px-1 py-0.5">
                    Payment History / Asset Classification
                  </td>
                  <td className="border px-1 py-0.5">STD</td>
                  <td className="border px-1 py-0.5">Standard Asset</td>
                </tr>
                <tr>
                  <td className="border px-1 py-0.5">
                    Payment History / Asset Classification
                  </td>
                  <td className="border px-1 py-0.5">SUB</td>
                  <td className="border px-1 py-0.5">Sub-Standard Asset</td>
                </tr>
                <tr>
                  <td className="border px-1 py-0.5">
                    Payment History / Asset Classification
                  </td>
                  <td className="border px-1 py-0.5">DBT</td>
                  <td className="border px-1 py-0.5">Doubtful Asset</td>
                </tr>
                <tr>
                  <td className="border px-1 py-0.5">
                    Payment History / Asset Classification
                  </td>
                  <td className="border px-1 py-0.5">LOS</td>
                  <td className="border px-1 py-0.5">Loss Asset</td>
                </tr>
                <tr>
                  <td className="border px-1 py-0.5">
                    Payment History / Asset Classification
                  </td>
                  <td className="border px-1 py-0.5">SMA</td>
                  <td className="border px-1 py-0.5">
                    Special Mention Account
                  </td>
                </tr>
                <tr>
                  <td className="border px-1 py-0.5">CRIF Highmark Score</td>
                  <td className="border px-1 py-0.5">PERFORM - Consumer</td>
                  <td className="border px-1 py-0.5">
                    Score based on credit history &amp; debt
                  </td>
                </tr>
                <tr>
                  <td className="border px-1 py-0.5">
                    Account Information - Account #
                  </td>
                  <td className="border px-1 py-0.5">CI-Ceased</td>
                  <td className="border px-1 py-0.5">
                    Institution ceased or membership terminated
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="py-20">
            <Disclaimer />
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center gap-3 mt-6 mb-2 w-full">
        {/* Primary Action: Print Button */}
        <button
          type="button"
          onClick={printDiv}
          disabled={isPrinting}
          className={`
      inline-flex items-center justify-center 
      px-5 py-2 
      text-sm font-semibold text-white 
      bg-blue-600 hover:bg-blue-700 
      rounded-lg shadow-sm
      focus:outline-none focus:ring-4 focus:ring-blue-100
      transition-all duration-200 ease-in-out
      ${isPrinting ? "opacity-75 cursor-not-allowed" : "active:scale-[0.98]"}
    `}
        >
          {isPrinting ? (
            <>
              {/* Minimal Spinner */}
              <svg
                className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
              Printing...
            </>
          ) : (
            "Print"
          )}
        </button>

        {/* Secondary Action: Close Button */}
        <button
          type="button"
          onClick={onClose}
          className="
      inline-flex items-center justify-center 
      px-5 py-2 
      text-sm font-semibold text-slate-700 
      bg-white border border-slate-200 
      hover:bg-slate-50 hover:text-slate-800
      rounded-lg shadow-sm 
      focus:outline-none focus:ring-4 focus:ring-slate-100 
      active:scale-[0.98] 
      transition-all duration-200 ease-in-out
    "
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default CrifScoreReportModal;
